import { getAuthHeaders, authedFetch } from './authService';
const HOSTNAME = process.env.REACT_APP_API_HOSTNAME ?? 'http://localhost:8000';

const notifyServiceError = (msg: string) => {
  try { window.dispatchEvent(new CustomEvent('wualt:notification:error', { detail: { message: msg } })); } catch (e) { /* ignore */ }
};

export async function getRoles(): Promise<any[]> {
  const url = `${HOSTNAME}/adminportal/roles`;
  const res = await authedFetch(url, { method: 'GET', headers: { ...getAuthHeaders() } });
  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    const msg = `Failed to fetch roles: ${res.status} ${txt}`;
    notifyServiceError(msg);
    throw new Error(msg);
  }
  const body = await res.json().catch(() => null);
  // expecting { success, data: { roles: [...] } } or { roles: [...] }
  const roles = body?.data?.roles ?? body?.roles ?? body?.data ?? [];
  return Array.isArray(roles) ? roles : [];
}
